// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1ijvw","imageUploader":"EGiftCard_imageUploader__SAY4o"};